import flexBoxHack from '@utils/flexBoxHack';
import { useGate } from 'effector-react';
import { Scrollbars } from 'react-custom-scrollbars';
import LibModalList from '../layouts/LibModalList';
import LibModalListBody from '../layouts/LibModalListBody';
import { LibItemsGate } from '../stores/libState';
import { IconItem } from './IconItem';
import { sandtableGroupIconList } from './sandtableGroupIconList';

export function LibGroupIcons() {
  useGate(LibItemsGate, sandtableGroupIconList);
  return (
    <LibModalList>
      <LibModalListBody>
        <Scrollbars>
          <div className="flex flex-wrap items-center justify-between p-15 gap-[24px]">
            {sandtableGroupIconList.map((x, i) => (
              <IconItem data={x} key={i} index={i} />
            ))}
            {flexBoxHack(80, 7)}
          </div>
        </Scrollbars>
      </LibModalListBody>
    </LibModalList>
  );
}
